import { useSelector } from "react-redux";

export default function ComponentHeader(props) {
  const { title, details } = props;

  // * Start ***Enable Dark Mode Feature***
  const textLightColorDynamic = useSelector((state) => state.setMode).css
    ?.textLightColor;
  return (
    <>
      <header className={` px-2`}>
        <h1
          className={` text-3xl font-serif tracking-wide text-center font-extrabold text-Brand-Color`}
        >
          {title}
        </h1>
        <h5
          className={` text-base font-serif tracking-wide text-center font-extrabold ${textLightColorDynamic}`}
        >
          {details}
        </h5>
      </header>
    </>
  );
}
